import { ICustomer } from "../Interfaces/Customer/ICustomer";
import { v4 } from 'uuid';
import { IHousingStatus } from "../Interfaces/Customer/IHousingStatus";
import { IState } from "../Interfaces/Common/IState";

export const generateCustomer = (
  dlState: IState,
  housingStatus: IHousingStatus
) => {
  const cust: ICustomer = {
    id: v4(),
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    dlnumber: "",
    county: "",
    customerNumber: 0,
    dateOfBirth: new Date("1/1/1990"),
    dlstateId: dlState.id,
    housingStatusId: housingStatus.id,
    dlstate: dlState,
    housingStatus: housingStatus,
    ssn: "",
    note: "",
    deleted: false,
    createdDate: new Date(),
    isPreviousCustomer: false,
    existingCustomerInfo: [],
    customerAddress: [],
    customerCredit: [],
    customerEmail: [],
    customerEmployment: [],
    customerIncomeDebt: [],
    customerReferences: [],
    customerPhone: [],
    appCustomers: [],
    customerPreviousCarCredits: [],
    customerVehicleInsurances: [],
    customerCustomFields: [],
    incomes: [],
    consentHistoryItems: []
  };

  return cust;
};